import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';
// import { Encrypt, Decrypt } from '../../middleware/CryptoMiddleWare';
import {  EncryptPreLogin, DecryptPreLogin, } from '../../middleware/CryptoMiddleWare';
import {consoleEnableKey} from '../../components/common/constant'

function htmlDecode(input) {
  const doc = new DOMParser().parseFromString(input, 'text/html');
  return doc.documentElement.textContent;
}

export const fetchWithEncryption = async ({ url, method, body, token, consoleEnable}) => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    PT: process.env.REACT_APP_API_KEY,
    Authorization: `Bearer ${token}`,
    // 'X-XSRF-TOKEN':cfsf.csrfToken,
  };
  if (consoleEnable) {
    console.log('REQUEST=>', `${url}`, body)
    console.log('TOKEN=>', token)
  }
  const response = await fetch(url, {
    method,
    headers,
    body:  body ? await EncryptPreLogin(JSON.stringify(body)) : undefined,
  });
  const res = await response.text();
  const data = await DecryptPreLogin(res);
  const encodedString = data;
  // if (consoleEnable) {
  //   console.log('RESPONSE =>', `${url}`, JSON.parse(htmlDecode(encodedString)))
  // }
  return JSON.parse(htmlDecode(encodedString));
};

export const createEncryptedAsyncThunk = (
  typePrefix,
  urlOrUrlCreator, // Can be a string or a function
  { method = 'POST', transUrl, prepareBody = (params) => params } = {},
  baseUrl = transUrl || process.env.REACT_APP_API_ENDPOINT,
) =>
  createAsyncThunk(typePrefix, async (params, { rejectWithValue, getState }) => {
    try {
      const localConsole = window && window.location ? _.toLower(window.location.hostname) === 'localhost' : false
      const {managementSlice} = getState()
      
      let consoleEnable = false
      if (!_.isEmpty(managementSlice) && !_.isEmpty(managementSlice.consoleEnable)) {
        if (managementSlice.consoleEnable.master_key === consoleEnableKey) {
          consoleEnable = managementSlice.consoleEnable.status
        }
      }
      if (localConsole && !consoleEnable) {
        consoleEnable = localConsole
      }
      
      // Determine the URL based on whether urlOrUrlCreator is a string or a function
      const fullUrl =
        typeof urlOrUrlCreator === 'function'
          ? `${baseUrl}${urlOrUrlCreator(params)}` // Call the function with params to get the URL
          : `${baseUrl}${urlOrUrlCreator}`; // Use the URL as is

      const body = method !== 'GET' ? prepareBody(params) : null;
      const response = await fetchWithEncryption({
        url: fullUrl,
        method,
        body,
        token: params.Usertoken,
        consoleEnable
      });
      if (consoleEnable) {
        console.log('RESPONSE =>', `${fullUrl}`, response)
      }
      return response;
    } catch (err) {
      return rejectWithValue(err.toString());
    }
  });
